import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Assignment from '@mui/icons-material/Assignment';
import { CollapseCard } from '@totalsoft/rocket-ui';
import FolderGeneralInfoSummary from './FolderGeneralInfoSummary';
import FolderGeneralInfoComponentAlpha from './FolderGeneralInfoComponentAlpha';

const FolderGeneralInfoCardAlpha = ({
  generalInfo,
  t,
  savingGeneralInfo,
  onSave,
  isDirty,
  validation,
  isNewFolder,
  onGeneralInfoChange,
  responsiblesOptions,
  folderTypes,
  openLinkedDocument,
  isFacilityApproval,
  onCalculateApproval,
  riskAnalysisTypes,
  partnersOptions
}) => {
  const [expanded, setExpanded] = useState(isNewFolder);
  const toggleExpanded = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  return (
    <CollapseCard
      icon={Assignment}
      iconColor='primary'
      title={t('Folder.GeneralData.GeneralInfo.Title')}
      expanded={expanded}
      onToggle={toggleExpanded}
      subheader={<FolderGeneralInfoSummary generalInfo={generalInfo} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      <FolderGeneralInfoComponentAlpha
        generalInfo={generalInfo}
        onGeneralInfoChange={onGeneralInfoChange}
        onSave={onSave}
        savingGeneralInfo={savingGeneralInfo}
        isDirty={isDirty}
        validation={validation}
        responsiblesOptions={responsiblesOptions}
        folderTypes={folderTypes}
        openLinkedDocument={openLinkedDocument}
        isFacilityApproval={isFacilityApproval}
        onCalculateApproval={onCalculateApproval}
        riskAnalysisTypes={riskAnalysisTypes}
        partnersOptions={partnersOptions}
        isNewFolder={isNewFolder}
      />
    </CollapseCard>
  );
};

FolderGeneralInfoCardAlpha.propTypes = {
  generalInfo: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  savingGeneralInfo: PropTypes.bool,
  onGeneralInfoChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  validation: PropTypes.object,
  isNewFolder: PropTypes.bool,
  responsiblesOptions: PropTypes.array.isRequired,
  folderTypes: PropTypes.array,
  openLinkedDocument: PropTypes.func,
  isFacilityApproval: PropTypes.bool,
  onCalculateApproval: PropTypes.func.isRequired,
  riskAnalysisTypes: PropTypes.array,
  partnersOptions: PropTypes.array.isRequired
};

export default withTranslation()(FolderGeneralInfoCardAlpha);
